import * as React from "react";
import * as ReactDOM from "react-dom";
import { Button } from "antd";
import { GuideIndicator } from "./guideIndicator";
import { guidePopupStyle, highlightTextStyle, guideHeaderStyle, guideProgressStyle, guideSkipStyle } from "./styles";
import { GuideProps } from "./guides";

export const LimitByContext: React.FC<GuideProps> = ({ onDone, onSkip, currentStep, totalSteps }) => {
  const [step, setStep] = React.useState(0);
  const [position, setPosition] = React.useState({ top: 200, left: 400 });

  React.useEffect(() => {
    const updatePosition = () => {
      const element = document.querySelector('[data-guide="limit-by-context"]');
      if (element) {
        const rect = element.getBoundingClientRect();
        const popupWidth = 350;
        let left = rect.left + rect.width / 2 - popupWidth / 2;
        if (left + popupWidth > window.innerWidth - 20) {
          left = window.innerWidth - popupWidth - 20;
        }
        if (left < 20) {
          left = 20;
        }
        setPosition({
          top: rect.bottom + 10,
          left: left,
        });
      }
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);
    const intervalId = setInterval(updatePosition, 500);

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
      clearInterval(intervalId);
    };
  }, []);

  React.useEffect(() => {
    if (step >= 1) {
      onDone();
    }
  }, [step]);

  if (step === 0) {
    return (
      <>
        <GuideIndicator selector='[data-guide="limit-by-context"]' />
        {ReactDOM.createPortal(
          <div style={{ position: "fixed", top: position.top, left: position.left, zIndex: 10001 }}>
            <div style={guidePopupStyle}>
              <div style={guideHeaderStyle}>
                <div className="font-semibold">
                  <span className="mr-4 text-sm uppercase">GUIDE</span>Filter by GVC
                </div>
                <div style={guideProgressStyle}>{currentStep}/{totalSteps}</div>
              </div>
              <div className="text-sm mb-4">
                The <span style={highlightTextStyle}>highlighted checkbox</span> filters the list by your selected GVC.
              </div>
              <div className="text-sm mb-4">
                By default, all items from all GVCs are shown. Enable this option to show only items from the currently
                selected GVC.
              </div>
              <div className="text-sm mb-4">This option is available on Workload, Identity, and Volume Set pages.</div>
              <div className="w-full flex justify-between items-center mt-4">
                <span style={guideSkipStyle} onClick={onSkip}>Skip all guides</span>
                <Button type={`primary`} onClick={() => setStep(1)}>
                  Got it
                </Button>
              </div>
            </div>
          </div>,
          document.getElementById("guide")!,
        )}
      </>
    );
  }

  return null;
};
